import gql from 'graphql-tag';

export const MyTripsQuery = gql`
    query getTravelerStayList {
        getTravelerStayList(
            includeInvitations: true
            includeCancelled: true
            pageSize: 50
        ) {
            travelerStayList {
                booking {
                    isPrimaryGuest
                    listing {
                        address {
                            city
                            stateProvince
                        }
                        photos(treatment: C4) {
                            uri
                        }
                    }
                    periodOfStay {
                        checkInDate
                        checkOutDate
                    }
                    priceDetails {
                        payments {
                            status
                            title
                            viewUrl
                        }
                    }
                    uuid
                }
                bookingState
                conversationId
                stayDisplayStatus {
                    code
                    description
                }
            }
        }
    }
`;
